// Что «умный подбор утеплителя» считает утеплителем.
//
// Источник каталога — те же `options`, из которых работает расчёт
// (/api/uniqueNomenclature). Это принципиально: там на каждую номенклатуру уже
// выбран самый дешёвый поставщик региона, и именно эта цена попадёт в строку
// заказа. Возьми подбор цены из другого места — и он показывал бы одно, а
// расчёт подставлял другое.
//
// Здесь только признаки строк: утеплитель ли это, плита ли, минвата или ЭППС.
// Арифметика — в insulationPickerView, объём упаковки — в insulationVolume.

/** Категории и названия, по которым номенклатура опознаётся как утеплитель. */
const INSULATION_CATEGORY = /утеплитель|пенополистирол/i;

// Единица измерения прямо в названии: миллилитры, граммы, килограммы и литры
// стоят только у аэрозолей и клеёв, у плит там миллиметры и штуки.
//
// Без этого правила «Утеплитель напыляемый Penoplex Fastfix 850 мл» — баллон
// пены за 789 ₽ — честно считался как 928 000 ₽/м³ и становился «самым
// дешёвым» сразу в четырёх применениях, где других товаров в прайсах нет.
const NON_BOARD_NAME = /\d+\s*(мл|гр|кг|л)( |$)/;

/** Товар продаётся не плитами — сравнивать его по цене за м³ бессмысленно. */
export const isNonBoardName = (name) => NON_BOARD_NAME.test(String(name || ''));

/**
 * Позиция справочника относится к подбору утеплителя.
 *
 * Категория проверяется вместе с названием: у экструдированного пенополистирола
 * категория гуляет между «Утеплитель Технониколь CARBON» и «Экструдированный
 * пенополистирол Технониколь CARBON» — это один и тот же товар.
 */
export const isInsulationOption = (name, data) => {
  if (isNonBoardName(name)) return false;
  const haystack = `${name || ''} ${(data && data.CATEGORY) || ''}`;
  return INSULATION_CATEGORY.test(haystack);
};

/** Материалы, у которых характеристика в третьем фильтре разная. */
export const INSULATION_KIND = {
  // Минвата, пенополистирол ПСБ и всё остальное — сравниваются по плотности.
  MINERAL: 'mineral',
  // Экструдированный пенополистирол — по прочности на сжатие, как просит задание.
  EXTRUDED: 'extruded',
};

export const KIND_LABELS = {
  [INSULATION_KIND.MINERAL]: 'Минеральная вата и пенополистирол',
  [INSULATION_KIND.EXTRUDED]: 'Экструдированный пенополистирол',
};

export const MEASURE_LABELS = {
  [INSULATION_KIND.MINERAL]: { title: 'Плотность', unit: 'кг/м³' },
  [INSULATION_KIND.EXTRUDED]: { title: 'Прочность на сжатие', unit: 'кПа' },
};

// Название — единственный надёжный признак вида: guide.type_material у
// утеплителя пуст целиком, а категория у ЭППС непостоянна.
export const insulationKindOf = (name) => (
  /^\s*экструдированный пенополистирол/i.test(String(name || ''))
    ? INSULATION_KIND.EXTRUDED
    : INSULATION_KIND.MINERAL
);
